import { IPageConfig } from 'redux-state/layout/types.page.js';
import { makeRequest } from 'utilities/fetch/api-gateway.js';

export enum PageJSONLoad {
  Loading = 'Loading',
  Success = 'Success',
  Fail = 'Fail',
  Reload = 'Reload',
}

export const getPageJson = async (path: string): Promise<IPageConfig<'Raw'>> => {
  let url = path.replace(/\/$/, '').replace(/^\//, '');
  url = `/${url}`;

  const options: RequestInit = { credentials: 'include' };
  const pageJson = await makeRequest<IPageConfig<'Raw'>>({ path: url, options, apiPrefix: true });
  return pageJson;
};
